import api from "./axios";

export const getEmailSettings = () =>
  api.get("/admin/email-settings").then((res) => res.data);

export const updateEmailSettings = (settings) =>
  api.put("/admin/email-settings", settings).then((res) => res.data);
